<template>
  <div>
    <form-wizard color="rgba(var(--vs-primary), 1)" :title="null" :subtitle="null" stepSize="sm"
                 next-button-text="Siguiente" back-button-text="Anterior" finish-button-text="Guardar"
                 @on-complete="save()"
                 @on-change="validateFields()">
      <tab-content title="Datos básicos" icon="ti-pencil-alt2">
        <vs-row>
          <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Código <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <vs-input class="inputx w-100" placeholder="Ingrese el código de la tarifa aquí" v-model="id" name="id"
                          v-validate="'required'" data-vv-name="id" />
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Nombre <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <vs-input class="inputx w-100" placeholder="Ingrese el nombre de la tarifa aquí" v-model="title"
                          name="title" v-validate="'required'" data-vv-name="title" />
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Fecha de inicio</label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="4">
                <vs-input type="date" class="inputx w-100" v-model="fromAt" name="fromAt" data-vv-name="fromAt" />
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Modo</label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <ul class="list-inline mb-0">
                  <li class="list-inline-item">
                    <vs-checkbox v-model="locked" vs-value="locked">Bloqueado</vs-checkbox>
                  </li>
                  <li class="list-inline-item">
                    <vs-checkbox v-model="autoRate" vs-value="autoRate">Autotarifa</vs-checkbox>
                  </li>
                  <li class="list-inline-item">
                    <vs-checkbox v-model="dayOut" vs-value="dayOut">Pasadía</vs-checkbox>
                  </li>
                </ul>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12" vs-sm="6">
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Valor tiquete perdido <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <vs-input type="number" class="inputx w-100" placeholder="Ingrese el valor del tiquete perdido aquí"
                          v-model="lostTicket" v-validate="'required'" data-vv-name="lostTicket" />
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Ajuste de tarifa <span style="color: red;">*</span> </label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <vs-input type="number" class="inputx w-100" placeholder="Ingrese el valor del ajuste de la tarifa aquí"
                          v-model="adjustment" v-validate="'required'" data-vv-name="adjustment" />
              </vs-col>
            </vs-row>
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Tipo de artículo <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="9" vs-xs="12" vs-sm="8">
                <vs-select class="w-100" v-model="itemType" placeholder="Seleccione el tipo de vehículo">
                  <vs-select-item :key="index" :value="item.code" :text="item.title" v-for="(item, index) in itemsType"
                                  v-validate="'required'" data-vv-name="itemType" name="itemType" />
                </vs-select>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-row class="mt-4">
              <vs-col vs-lg="2" vs-xs="12" vs-sm="12" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Detalle de tarifa</label>
              </vs-col>
              <vs-col vs-lg="10" vs-xs="12" vs-sm="12">
                <vs-textarea class="inputx w-100"
                             placeholder="Ingrese una descripción para la tarifa. Ej: Minuto carro $110 pesos"
                             v-model="description"></vs-textarea>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>

      <tab-content title="Tiempos de gracia" icon="ti-time">
        <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="6">
            <vs-row class="mt-4">
              <vs-col vs-lg="5" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Gracia de entrada <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="8">
                <vue-timepicker style="size: 200px;" class="inputx w-100" v-model="graceLiquidation" close-on-complete
                                v-validate="'required'" data-vv-name="graceLiquidation"
                                name="graceLiquidation"></vue-timepicker>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="3" vs-xs="12" vs-sm="2">
            <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12" class="d-flex justify-content-start mt-1">
                <vs-checkbox v-model="addEntryGrace" name="addEntryGrace" vs-value="addEntryGrace">Cobrar gracia de
                  entrada
                </vs-checkbox>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="5" vs-xs="12" vs-sm="6">
            <vs-row class="mt-4">
              <vs-col vs-lg="5" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Gracia después de pago <span style="color: red;">*</span></label>
              </vs-col>
              <vs-col vs-lg="4" vs-xs="12" vs-sm="8">
                <vue-timepicker class="inputx w-100" v-model="graceTime" close-on-complete v-validate="'required'"
                                data-vv-name="graceTime" name="graceTime"></vue-timepicker>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>

      <tab-content title="Tiempo de corte" icon=" ti-pulse">
        <vs-row>
          <vs-col vs-lg="2" vs-xs="12" vs-sm="2">
            <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12" class="d-flex justify-content-start">
                <vs-checkbox v-model="useMax24h" vs-value="useMax24h">Tiempo de corte</vs-checkbox>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="6" v-if="useMax24h">
            <vs-row class="mt-4">
              <vs-col vs-lg="4" vs-xs="12" vs-sm="2" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Hora de corte </label>
              </vs-col>
              <vs-col vs-lg="8" vs-xs="12" vs-sm="10">
                <vue-timepicker style="size: 200px;" class="inputx w-100" v-model="cutTime"
                                close-on-complete></vue-timepicker>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12" vs-sm="6" v-if="useMax24h">
            <vs-row class="mt-4">
              <vs-col vs-lg="2" vs-xs="12" vs-sm="2" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Valor </label>
              </vs-col>
              <vs-col vs-lg="10" vs-xs="12" vs-sm="10">
                <vs-input type="number" class="inputx w-100" placeholder="Valor de corte" v-model="valueMax24h" />
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>

      <tab-content title="Impuestos" icon=" ti-money">
        <vs-row>
          <vs-col vs-lg="4" vs-xs="12" vs-sm="4">
            <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12" class="d-flex justify-content-start">
                <vs-checkbox v-model="taxes" vs-value="taxes">Aplica impuestos</vs-checkbox>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col vs-lg="8" vs-xs="12" vs-sm="8" v-if="showTaxesMode">
            <vs-row class="mt-4">
              <vs-col vs-lg="2" vs-xs="12" vs-sm="2" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Valor </label>
              </vs-col>
              <vs-col vs-lg="10" vs-xs="12" vs-sm="10">
                <vs-select class="w-100" v-model="taxesMode"
                           placeholder="Seleccione el modo de aplicación del impuesto">
                  <vs-select-item :key="index" :value="item.id" :text="item.text" v-for="(item, index) in taxesType" />
                </vs-select>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>

      <tab-content title="Condiciones de salida" icon=" ti-arrow-right">
        <vs-row>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Tipo de salida</label>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <vs-checkbox v-model="exitOpen" vs-name="exitOpen" vs-value="exitOpen" id="exitOpen">
                  Con tarjeta abierta
                </vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <vs-checkbox v-model="exitClose" vs-name="exitClose" vs-value="exitClose" id="exitClose">
                  Con tarjeta cerrada
                </vs-checkbox>
              </vs-col>
            </vs-row>
          </vs-col>

          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-row class="mt-4">
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <label class="vs-input--label mb-0">Tipo de gracia</label>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <vs-checkbox v-model="exitSubsegments" vs-name="exitSubsegments" vs-value="exitSubsegments"
                             id="exitSubsegments">
                  Gracia de subsegmento
                </vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <vs-checkbox v-model="exitSegments" vs-name="exitSegments" vs-value="exitSegments" id="exitSegments">
                  Gracia de segmento
                </vs-checkbox>
              </vs-col>
              <vs-col vs-lg="3" vs-xs="12" vs-sm="4" class="d-flex align-items-center justify-content-start">
                <vs-checkbox v-model="exitReliquidate" vs-name="exitReliquidate" vs-value="exitReliquidate">
                  Reliquidar sin iniciar tiempo
                </vs-checkbox>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>

      <tab-content title="Segmentos y bloques" icon="ti-settings">
        <vs-row>
          <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
            <vs-row class="mt-4">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <vs-card>
                  <vs-row style="margin-bottom: 1rem;">
                    <vs-col vs-lg="6" vs-xs="6" vs-sm="6">
                      <h3 class="card-title d-flex">Segmentos<span style="color: red;">*</span></h3>
                    </vs-col>
                    <vs-col vs-lg="6" vs-xs="6" vs-sm="6">
                      <div class="d-flex ">
                        <vs-button icon="add" color="primary" class="flex-shrink-0 ml-auto" @click="addSection()">
                          Añadir segmento
                        </vs-button>
                      </div>
                    </vs-col>
                  </vs-row>

                  <div class="columns">
                    <div class="column" id="tbl-segmens">
                      <vs-table :data="getSections()"
                                @selected="handleSelected">
                        <template slot="header"></template>
                        <template slot="thead">
                          <vs-th>Código</vs-th>
                          <vs-th>Día desde</vs-th>
                          <vs-th>Hora desde</vs-th>
                          <vs-th>Día hasta</vs-th>
                          <vs-th>Horá hasta</vs-th>
                          <vs-th>Acciones</vs-th>
                        </template>

                        <template slot-scope="{data}">
                          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                            <vs-td :data="data[indextr].id"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              {{ data[indextr].id }}
                            </vs-td>

                            <vs-td :data="data[indextr].dayFrom"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              <b-field>
                                <b-select placeholder="Seleccione el día" expanded v-model="data[indextr].dayFrom">
                                  <option v-for="option in days" :value="option.id" :key="option.name"
                                          :id="option.name">
                                    {{ option.name }}
                                  </option>
                                </b-select>
                              </b-field>
                            </vs-td>

                            <vs-td :data="data[indextr].hourFrom"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              <div>
                                <vue-timepicker class="choosenPickerSection" v-model="data[indextr].hourFrom"
                                                style="margin-top: 5px;" close-on-complete></vue-timepicker>
                              </div>
                            </vs-td>

                            <vs-td :data="data[indextr].dayTo"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              <b-field>
                                <b-select placeholder="Seleccione el día" expanded v-model="data[indextr].dayTo"
                                          name="dayTo">
                                  <option v-for="option in days" :value="option.id" :key="option.id2" :id="option.id">
                                    {{ option.name }}
                                  </option>
                                </b-select>
                              </b-field>
                            </vs-td>

                            <vs-td :data="data[indextr].hourTo"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              <div>
                                <vue-timepicker class="choosenPickerSection" v-model="data[indextr].hourTo"
                                                style="margin-top: 5px;" close-on-complete></vue-timepicker>
                              </div>
                            </vs-td>

                            <vs-td :data="data[indextr].id"
                                   :class="{ 'chosenSection': selected != null && selected.id === data[indextr].id }">
                              <b-field>
                                <vs-button color="danger" type="filled" icon="delete"
                                           @click="deleteSection(data[indextr])"
                                           style="margin-right: 5px;"></vs-button>
                                <vs-button color="primary" type="filled" icon="add"
                                           @click="addBlocking(data[indextr].id)"></vs-button>
                              </b-field>
                            </vs-td>
                          </vs-tr>
                        </template>
                      </vs-table>
                    </div>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>

            <vs-row class="mt-4" v-if="!!selected">
              <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
                <vs-card>
                  <vs-row style="margin-bottom: 1rem;">
                    <vs-col vs-lg="6" vs-xs="6" vs-sm="6">
                      <h3 class="card-title d-flex">Bloques del segmento {{ selected.id }}</h3>
                    </vs-col>
                  </vs-row>

                  <div class="columns">
                    <div class="column">
                      <div class="columns">
                        <div id="tbl-blocks" class="column">
                          <vs-table :data="getBlocks()">
                            <template slot="header"></template>
                            <template slot="thead">
                              <vs-th>Código</vs-th>
                              <vs-th>Tiempo</vs-th>
                              <vs-th>Repetir</vs-th>
                              <vs-th>Siguiente</vs-th>
                              <vs-th>Valor</vs-th>
                              <vs-th>Acciones</vs-th>
                            </template>

                            <template slot-scope="{data}">
                              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="data[indextr].id">
                                  {{ data[indextr].id }}
                                </vs-td>

                                <vs-td :data="data[indextr].time">
                                  <b-field>
                                    <vue-timepicker class="inputx w-50" v-model="data[indextr].time"
                                                    close-on-complete></vue-timepicker>
                                  </b-field>
                                </vs-td>

                                <vs-td :data="data[indextr].repeat">
                                  <b-field>
                                    <b-input placeholder="Ingrese un valor..." type="number"
                                             v-model="data[indextr].repeat" name="repeat"></b-input>
                                  </b-field>
                                </vs-td>

                                <vs-td :data="data[indextr].next">
                                  <b-field>
                                    <b-input placeholder="Ingrese un valor..." type="number"
                                             v-model="data[indextr].next"
                                             name="next" v-on:input="validLineBlock()"
                                             :class="`${data[indextr].nextError ? 'has-error' : ''}`"></b-input>
                                    <span class="show-error" v-if="data[indextr].nextError">No existe un bloque con este
                                      código</span>
                                  </b-field>
                                </vs-td>

                                <vs-td :data="data[indextr].value">
                                  <b-field>
                                    <b-input placeholder="Ingrese un valor..." type="number"
                                             v-model="data[indextr].value"
                                             name="value"></b-input>
                                  </b-field>
                                </vs-td>

                                <vs-td :data="data[indextr].id">
                                  <b-field>
                                    <b-button type="is-danger" title="Eliminar"
                                              @click="deleteBlocking(data[indextr].id)"
                                              icon-right="delete" />
                                  </b-field>
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                      </div>
                    </div>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
      </tab-content>
    </form-wizard>
  </div>
</template>

<style>
.chosenSection {
  background-color: #b6e9fd !important;
  padding: 5px;
  height: 50px;
}

.is-selected {
  background-color: #b6e9fd !important;
  color: black !important;
}

.chosenPickerSection {
  width: 40px;
  position: absolute !important;
  z-index: 50;
}
</style>
<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import VueTimepicker from 'vue2-timepicker'
import 'vue2-timepicker/dist/VueTimepicker.css'
import { ROUTES } from '@/global/api_routes'
import { configToast, TOAST_TYPES } from '@/global/toast'
import moment from 'moment'
import { confirmation } from '@/global/utils'

export default {
  name: 'FormRate',
  props: ['company', 'rate', 'newRate', 'typeDayOut'],
  data: () => ({
    taxesType: [{ id: 'D', text: 'Deducir' }, { id: 'A', text: 'Agregar' }],
    id: null,
    title: null,
    fromAt: null,
    locked: null,
    autoRate: null,
    dayOut: null,
    lostTicket: null,
    adjustment: null,
    itemsType: [],
    itemType: null,
    description: '',
    graceTime: null,
    graceLiquidation: null,
    useMax24h: null,
    cutTime: null,
    valueMax24h: null,
    exitOpen: null,
    exitClose: null,
    exitReliquidate: null,
    exitSubsegments: null,
    exitSegments: null,
    taxes: null,
    taxesMode: null,
    sections: [],
    days: [
      { name: 'Lunes', id: 1 },
      { name: 'Martes', id: 2 },
      { name: 'Miércoles', id: 3 },
      { name: 'Jueves', id: 4 },
      { name: 'Viernes', id: 5 },
      { name: 'Sábado', id: 6 },
      { name: 'Domingo', id: 7 },
      { name: 'Festivo', id: 8 },
      { name: 'Especial', id: 9 }
    ],
    initialDay: null,
    finalDay: null,
    initialHour: null,
    finalHour: null,
    idBlock: null,
    time: null,
    repeat: null,
    next: null,
    value: null,
    actualCode: null,
    selected: null,
    currentPage: 1,
    currentPageBlockings: 1,
    blockings: [],
    addEntryGrace: null,
    indexWizard: 0,
    showTaxesMode: false,
    totalPagesSections: 1,
    perPageSection: 3
  }),
  watch: {
    rate() {
      this.getRate()
    },
    newRate() {
      if (newRate) {
        this.cleanForm()
      }
    },
    exitOpen() {
      this.exitOpen === 'exitOpen'
        ? document.getElementById('exitClose')
          .setAttribute('disabled', true)
        : document.getElementById('exitClose')
          .removeAttribute('disabled')
    },
    exitClose() {
      this.exitClose === 'exitClose'
        ? document.getElementById('exitOpen')
          .setAttribute('disabled', true)
        : document.getElementById('exitOpen')
          .removeAttribute('disabled')
    },
    exitSubsegments() {
      this.exitSubsegments === 'exitSubsegments'
        ? document.getElementById('exitSegments')
          .setAttribute('disabled', true)
        : document.getElementById('exitSegments')
          .removeAttribute('disabled')
    },
    exitSegments() {
      this.exitSegments === 'exitSegments'
        ? document.getElementById('exitSubsegments')
          .setAttribute('disabled', true)
        : document.getElementById('exitSubsegments')
          .removeAttribute('disabled')
    },
    taxes() {
      if (this.taxes === 'taxes') {
        this.showTaxesMode = true
      }
    }
  },
  mounted() {
    this.getItemsType()
    this.useMax24h = null
    this.getRate()
    if (this.newRate) {
      this.cleanForm()
    }
  },
  methods: {
    toast(message, type = TOAST_TYPES.INFO) {
      const instance = configToast(this, '#rates_container')
      return instance.open(message, type)
    },
    getItemsType() {
      this.$http
        .get(ROUTES.DASHBOARD.ENTITY.GET_LIST_BY_FATHER, {
          params: {
            kindFather: 958
          }
        })
        .then(({ data }) => {
          if (data.code > 0) {
            this.itemsType = data.info
          }
        })
    },
    calculateMinutes(time) {
      let hour = Number(time.HH)
      let minutes = (hour * 60) + Number(time.mm)
      return minutes
    },
    transformMinutes(minute) {
      let hour = Math.trunc(minute / 60) <= 9 ? '0' + Math.trunc(minute / 60) : Math.trunc(minute / 60)
      let minutes = (minute % 60) <= 9 ? '0' + (minute % 60) : (minute % 60)
      let time = { HH: String(hour), mm: String(minutes) }
      return time
    },
    convertToText(time) {
      let hourText = ''
      if (time.HH) {
        hourText = time.HH + ':' + time.mm + ':00'
      }
      return hourText
    },
    convertCheck(check) {
      return check != null ? 'Y' : 'N'
    },
    /**
     * valida si seleccionaron pasadia envia unidad tarifa pasa dia sino envia nulo
     * @param check
     * @returns {null}
     */
    convertDayOut(check) {
      return !check ? null : { code: this.typeDayOut.code }
    },
    save() {
      try {
        this.$vs.loading()
        this.$validator.validateAll().then((result) => {
          if (!result) {
            this.$vs.loading.close()
            return this.toast('Hay campos pendientes por ingresar o con información inválida. Revisa nuevamente el formulario', TOAST_TYPES.ERROR)
          } else {
            if (this.validateSegments()) {
              const obj = this.getObject()
              const method = this.actualCode ? 'put' : 'post'
              this.$http[method](ROUTES.DASHBOARD.RATES.SAVE_RATE, obj)
                .then(({ data }) => {
                  if (data.code > 0) {
                    this.toast(
                      'La tarifa se ha guardado correctamente',
                      TOAST_TYPES.SUCCESS
                    )
                    this.cleanForm()
                    this.$emit('updateRates')
                    this.$emit('removeStyle')
                    return
                  }
                  return this.toast(data.message, TOAST_TYPES.ERROR)
                })
                .catch(() => {
                  this.toast('Se ha producido un error', TOAST_TYPES.ERROR)
                  this.$vs.loading.close()
                })
                .finally(() => {
                  this.$vs.loading.close()
                })
            } else {
              this.$vs.loading.close()
              return this.toast('Hay campos pendientes por ingresar en segmentos y/o bloques', TOAST_TYPES.ERROR)
            }
          }
        })
      } catch (e) {
        console.error(e)
      }
    },
    getObject() {
      return {
        code: this.actualCode,
        company: { code: this.company },
        id: this.id,
        title: this.title,
        status: 'A',
        instant: moment(new Date()).format('YYYY-MM-D HH:mm:ss'),
        locked: this.convertCheck(this.locked),
        lostTicket: this.lostTicket,
        main: this.convertCheck(this.autoRate),
        graceLiquidation: this.graceLiquidation ? this.calculateMinutes(this.graceLiquidation) : 0,
        graceTime: this.graceTime ? this.calculateMinutes(this.graceTime) : 0,
        tariffFullValue: null,
        tariffFullTime: null,
        taxes: this.convertCheck(this.taxes),
        taxesMode: this.taxesMode,
        exitOpen: this.convertCheck(this.exitOpen),
        exitClose: this.convertCheck(this.exitClose),
        exitSubsegments: this.convertCheck(this.exitSubsegments),
        exitSegments: this.convertCheck(this.exitSegments),
        exitReliquidate: this.convertCheck(this.exitReliquidate),
        description: this.description,
        adjustment: this.adjustment,
        tariffValue: null,
        tariffType: this.convertDayOut(this.dayOut),
        liquidationGraceTime: null,
        outGraceTime: null,
        useMax24h: this.convertCheck(this.useMax24h),
        valueMax24h: this.valueMax24h,
        fromAt: this.fromAt,
        itemType: { code: this.itemType },
        segmentList: this.getSegmentList(),
        cutTime: this.useMax24h === 'useMax24h' ? this.cutTime.HH ? this.convertToText(this.cutTime) : this.cutTime : null,
        addEntryGrace: this.convertCheck(this.addEntryGrace)
      }
    },
    addSection() {
      const tempData = [
        ...this.sections,
        {
          id: this.sections.length + 1,
          initialDay: null,
          initialHour: null,
          finalDate: null,
          finalHour: null,
          blockings: []
        }
      ]
      this.sections = tempData
    },
    getSections() {
      return this.sections.filter((item) => !item.deleted)
    },
    getRate() {
      if (this.rate) {
        this.actualCode = this.rate.code
        this.id = this.rate.id
        this.title = this.rate.title
        this.fromAt = moment(this.rate.fromAt).format('YYYY-MM-DD')
        this.locked = this.rate.locked === 'Y' ? 'locked' : null
        this.autoRate = this.rate.main === 'Y' ? 'autoRate' : null
        this.lostTicket = this.rate.lostTicket
        this.adjustment = this.rate.adjustment
        this.itemType = this.rate.itemType ? this.rate.itemType.code : null
        this.dayOut = !!(this.rate.tariffType && this.rate.tariffType.code === this.typeDayOut.code)
        this.description = this.rate.description
        this.graceTime = this.transformMinutes(this.rate.graceTime)
        this.graceLiquidation = this.transformMinutes(this.rate.graceLiquidation)
        this.useMax24h = this.rate.useMax24h === 'Y' ? 'useMax24h' : null
        this.valueMax24h = this.rate.valueMax24h
        this.exitOpen = this.rate.exitOpen === 'Y' ? 'exitOpen' : null
        this.exitClose = this.rate.exitClose === 'Y' ? 'exitClose' : null
        this.taxes = this.rate.taxes === 'Y' ? 'taxes' : null
        this.taxesMode = this.rate.taxesMode ? this.rate.taxesMode : null
        this.exitSegments = this.rate.exitSegments === 'Y' ? 'exitSegments' : null
        this.exitSubsegments = this.rate.exitSubsegments === 'Y' ? 'exitSubsegments' : null
        this.exitReliquidate = this.rate.exitReliquidate === 'Y' ? 'exitReliquidate' : null
        this.sections = this.rate.segmentList.map((item, index) => ({
          code: item.code,
          id: index + 1,
          dayTo: item.finalDay,
          dayFrom: item.initialDay,
          hourTo: item.finalHour,
          hourFrom: item.initialHour,
          blockings: item.blockList
            .slice()
            .sort((a, b) => a.id - b.id)
            .map((block) => ({
              code: block.code,
              id: block.id,
              next: block.next,
              time: block.time ? this.transformMinutes(block.time) : 0,
              repeat: block.repeat,
              value: block.value
            }))
        }))
        this.selected = this.sections[0]
        this.cutTime = this.rate.cutTime
        this.addEntryGrace = this.rate.addEntryGrace === 'Y' ? 'addEntryGrace' : null
        this.totalPagesSections = Math.ceil(this.rate.segmentList.length / this.perPageSection)
      }
    },
    cleanForm() {
      this.id = null
      this.title = null
      this.fromAt = null
      this.locked = null
      this.autoRate = null
      this.lostTicket = null
      this.adjustment = null
      this.itemsType = []
      this.itemType = null
      this.description = ''
      this.graceTime = null
      this.graceLiquidation = null
      this.useMax24h = null
      this.cutTime = null
      this.valueMax24h = null
      this.exitOpen = null
      this.exitClose = null
      this.exitReliquidate = null
      this.exitSubsegments = null
      this.exitSegments = null
      this.taxes = null
      this.taxesMode = null
      this.sections = []
      this.initialDay = null
      this.finalDay = null
      this.initialHour = null
      this.finalHour = null
      this.idBlock = null
      this.time = null
      this.repeat = null
      this.next = null
      this.value = null
      this.actualCode = null
      this.addEntryGrace = null
    },
    openPickerSections(dataName, sectionId, propertyName) {
      this.pickerSelection = {
        selection: dataName,
        sectionId,
        propertyName
      }
      this.pickerSelectorOpen = true
    },
    getSection(section) {
      const newSection = section
      this.selected = { ...newSection }
      if (!this.selected.blockings) {
        this.selected.blockings = []
      }
    },
    deleteSection(section) {
      confirmation(this, '¿Deseas elmiminar la sección seleccionada?').then(
        (result) => {
          if (!result) {
            return
          }
          let index = this.sections.findIndex(item => item.code === section.code)
          if (section.code) {
            this.sections.splice(index, 1)
            this.$http.delete(ROUTES.DASHBOARD.RATES.DELETE_SEGMENT_RATE, {
              data: {
                segmentTariffCode: section.code
              }
            }).then(({ data }) => {
              this.isLoading = false
              if (data.code > 0) {
                this.toast('La tarifa se ha eliminado correctamente', TOAST_TYPES.SUCCESS)
                this.getSections()
                return
              }
              this.toast(data.message, TOAST_TYPES.ERROR)
            })
          } else {
            let indexId = this.sections.findIndex(item => item.id === section.id)
            this.sections.splice(indexId, 1)
          }
        }
      )
    },
    addBlocking(sectionId) {
      const index = this.sections.findIndex(
        (sec) => sec.id == sectionId
      )
      this.sections[index].blockings = [
        ...this.sections[index].blockings,
        {
          id: this.sections[index].blockings.length + 1,
          time: null,
          repeat: null,
          next: null,
          value: null
        }
      ]

      this.selected = this.sections[index]
    },
    getBlocks() {
      return this.selected.blockings.filter((item) => !item.deleted)
    },
    validLineBlock() {
      this.selected.blockings.forEach((block) => {
        let found = 0
        let replyIdBlocks = 0
        this.selected.blockings.forEach((blockTemp) => {
          if (block.next == blockTemp.id) {
            found++
          }
          if (block.id == blockTemp.id) {
            replyIdBlocks++
          }
        })
        block.nextError = found == 0
        block.idError = replyIdBlocks >= 2
      })
    },
    deleteBlocking(id) {
      confirmation(this, `¿Deseas eliminar el bloque con código ${id}?`).then(
        (result) => {
          if (!result) {
            return
          }
          const indexBlocking = this.selected.blockings.findIndex(
            (block) => block.id == id
          )
          if (
            indexBlocking >= 0 &&
            this.selected.blockings[indexBlocking].code
          ) {
            this.selected.blockings = this.selected.blockings.map((item) => ({
              ...item,
              deleted: item.id == id
            }))
            return
          } else {
            this.selected.blockings.splice(indexBlocking, 1)
          }
        }
      )
    },
    getSegmentList() {
      if (this.validateBlocks()) {
        return this.sections.map((item) => ({
          code: item.code,
          initialDay: item.dayFrom,
          finalDay: item.dayTo,
          initialHour: item.hourFrom.HH ? this.convertToText(item.hourFrom) : item.hourFrom,
          finalHour: item.hourTo.HH ? this.convertToText(item.hourTo) : item.hourTo,
          status: item.deleted ? 'D' : 'A',
          blockList: item.blockings.map((block) => ({
            code: block.code,
            id: block.id,
            next: parseInt(block.next),
            time: block.time ? this.calculateMinutes(block.time) : 0,
            repeat: parseInt(block.repeat),
            value: parseFloat(block.value),
            status: block.deleted ? 'D' : 'A'
          }))
        }))
      } else {
        return this.toast('Hay campos pendientes por ingresar en segmentos y/o bloques', TOAST_TYPES.ERROR)
      }
    },
    validateCutFields() {
      let result = false
      if (this.useMax24h === 'useMax24h') {
        if (this.cutTime && this.valueMax24h) {
          result = this.valueMax24h > 0 ? true : false
        } else {
          result = false
        }
      } else {
        result = true
      }
      return result
    },
    validateFields() {
      switch (this.indexWizard) {
        case 0:
          if (!this.validateBasicData()) {
            this.toast('Hay campos obligatorios pendientes por ingresar en la sección de datos básicos. Revisa nuevamente la sección anterior.', TOAST_TYPES.ERROR)
          }
          break
        case 1:
          if (!this.validateGraceTime()) {
            this.toast('Debe asignar los tiempos de gracia. Revisa nuevamente la sección anterior.', TOAST_TYPES.ERROR)
          }
          break
        case 2:
          if (!this.validateCutFields()) {
            this.toast('Debe especificar una hora de corte y un valor de corte mayor a cero (0). Revisa nuevamente la sección anterior.', TOAST_TYPES.ERROR)
          }
          break
        case 3:
          if (!this.validateTaxes()) {
            this.toast('Debe especificar el modo de aplicación del impuesto. Revisa nuevamente la sección anterior.', TOAST_TYPES.ERROR)
          }
          break
        default:
      }
      this.indexWizard++
      this.removeTableClass()
    },
    validateBasicData() {
      let result = false
      if (this.id && this.title && this.lostTicket && this.adjustment && this.itemType) {
        result = true
      }
      return result
    },
    validateGraceTime() {
      let result = false
      if (this.graceLiquidation && this.graceTime) {
        result = true
      }
      return result
    },
    validateTaxes() {
      let result = false
      if (this.taxes === 'taxes') {
        result = this.taxesMode ? true : false
      } else {
        result = true
      }
      return result
    },
    handleSelected(tr) {
      this.selected = tr
    },
    validateSegments() {
      let save = true
      if (this.sections.length > 0) {
        this.sections.forEach(segment => {
          if (!segment.hourFrom || !segment.hourTo) {
            save = false
          }
        })
      } else {
        save = false
      }
      return save
    },
    validateBlocks() {
      let save = true
      if (this.selected) {
        if (!this.selected.deleted && this.selected.blockings.length > 0) {
          this.selected.blockings.forEach(block => {
            if (!block.time) {
              save = false
            }
          })
        }
      }
      return save
    },
    removeTableClass() {
      setTimeout(() => {
        console.log('Eliminando clase de la tabla')
        let el = document.getElementById('tbl-blocks')
        let table = el.querySelector('table')
        let vsTable = el.querySelector('.vs-table--content')
        vsTable.classList.remove('vs-table--content')
        table.classList.remove('vs-table--tbody-table')

        console.log('Eliminando clase de la tabla')
        el = document.getElementById('tbl-segmens')
        table = el.querySelector('table')
        table.classList.remove('vs-table--tbody-table')
        vsTable = el.querySelector('.vs-table--content')
        vsTable.classList.remove('vs-table--content')
      }, 200)
    }
  },
  components: {
    FormWizard,
    TabContent,
    VueTimepicker
  }
}
</script>
